import React from 'react'
import styles from "./Filters.module.css"
import { RangeCalendar, SortInput, SearchInput } from "../../../../components"

const Filters = () => {
  return (
    <div className={styles.container}>
          <div className={styles.search}>
            <SearchInput />
          </div>
          <div className={styles.filters}>
            <RangeCalendar />
            <SortInput />
          </div>
          
    </div>
  )
}

export default Filters
